var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.show)?_c('div',{ref:"editor",staticClass:"editor",style:({height: _vm.height ? _vm.height+'px' : '344px', width: _vm.width ? _vm.width+'px' : '100%'})}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }